<template>
  <div>
    <v-layout
      fill-height
      align-center
    >
      <v-spacer />
      <v-btn
        :disabled="disabled"
        color="primary"
        small
        icon
        @click="showNoteDialog('add')"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-dialog
        v-model="noteDialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-text>
            <v-form>
              <v-textarea
                v-model="note"
                label="Заметка"
              />

              <v-btn
                small
                color="primary"
                @click="save"
              >
                Ок
              </v-btn>
              <v-btn
                small
                @click="noteDialog = false"
              >
                Отмена
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <div
      class="pa-1 worked-variant-table"
      :style="{
        height: blockNotesHeight + 'px',
        'overflow-y': 'auto',
        'overflow-x': 'hidden'
      }"
    >
      <v-list>
        <v-list-tile
          v-for="item in notes"
          :key="item.id"
          class="compact"
        >
          <v-list-tile-content>
            <div>
              <span
                style="color: rgba(0,0,0,.54);"
              >{{ item.author }}: {{ item.changedAt | dateTime }} </span><span> {{ item.text }}</span>
            </div>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout>
              <span>
                <v-icon
                  :disabled="disabled"
                  @click="showNoteDialog('change', item.id, item.text)"
                >edit</v-icon>
              </span>
              <span>
                <v-icon
                  :disabled="disabled"
                  @click="deleteNote(item.id)"
                >delete</v-icon>
              </span>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </div>
  </div>
</template>
<script>
import {
  createNote,
  updateNote,
  deleteNote,
} from "../../../backend/goodsDetailsApi.js";
import auth from "../../../auth.js";

export default {
  props: ["disabled", "id", "value"],
  data() {
    return {
      action: null,
      noteDialog: false,
      note: "",
      noteId: 0,
      user: null,
      notes: [],
    };
  },
  computed: {
    blockNotesHeight() {
      return window.innerHeight - 498;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.notes = val;
      },
      immediate: true,
    },
  },
  created() {
    this.user = auth.getUser();
  },
  methods: {
    save() {
      if (this.action === "add") {
        this.addNote();
      } else if (this.action === "change") {
        this.changeNote();
      }
    },
    async addNote() {
      await createNote(this.id, this.note);
      this.$emit("updateNotes");
      this.noteDialog = false;
      this.note = "";
      this.noteId = 0;
      this.action = null;
    },
    async changeNote() {
      await updateNote(this.id, this.noteId, this.note);
      this.$emit("updateNotes");
      this.noteDialog = false;
      this.note = "";
      this.noteId = 0;
      this.action = null;
    },
    async deleteNote(noteId) {
      if (!this.disabled) {
        await deleteNote(this.id, noteId);
        this.$emit("updateNotes");
      }
    },
    showNoteDialog(action, noteId, note) {
      if (!this.disabled && this.user.hasEmployee) {
        this.action = action;
        this.noteId = noteId;
        this.note = note;
        this.noteDialog = true;
      } else {
        this.showInfo("Пользователь не привязан к сотруднику");
      }
    },
  },
};
</script>
